export const INTEGRATIONS = {
  XML: 'XML',
  API: 'API',
  LEADS: 'LEADS'
};
